import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import BaseInput from "../components/all-inputs/BaseInput";
import { Box, Button, Typography } from "@mui/material";
import { TICKETING_API } from "../api";
import BaseTextArea from "../components/all-inputs/BaseTextArea";
import { useDispatch } from "react-redux";
import { addErrorMessage, addNewMessage, addSuccessMessage } from "../slice";

function RegisterComplaints() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [information, setInformation] = useState({ discription: "" });
  const { title } = useSelector((state) => state.PageTitle);

  const { mutateAsync: AddQuestion } = useMutation((body) => TICKETING_API.AddQuestion(body), {
    onError: ({ response }) => {
      //todo : check shodan
      dispatch(addErrorMessage(response));
    },
    onSuccess: ({ data }) => {
      if (data.success) {
        let body = { questionId: data.data.id, message: information.discription };
        AddQuestionInfo(body);
      }
    },
  });

  const { mutateAsync: AddQuestionInfo } = useMutation(
    (body) => TICKETING_API.AddQuestionInfo(body),
    {
      onError: ({
        response: {
          data: { message },
        },
      }) => {
        //todo : check shodan
        dispatch(
          addNewMessage({
            id: "error-on-AddQuestion",
            text: message,
            type: "error",
          })
        );
      },
      onSuccess: ({ data }, body) => {
        if (data.success) {
          navigate(`/ticketing`);
        }
        dispatch(addSuccessMessage(data.message));
      },
    }
  );

  const handleSubmitForm = async () => {
    let body = { title: information.title, categoryId: id };
    await AddQuestion(body);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      justifyContent="center"
      alignItems="center"
      height={{ xs: "78vh", sm: "84vh", lg: "68vh", xl: "75vh" }}
    >
      <Box display="flex" alignItems="center" justifyContent="center" width="100%">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="end"
          justifyContent="center"
          bgcolor="#eeeeee"
          borderRadius={3}
          p={4}
        >
          <Typography variant="h1" mb={3} fontSize="22px" fontWeight={600} letterSpacing="-0.44px">
            {title}
          </Typography>
          <Typography
            variant="h2"
            component="label"
            htmlFor="ticket-title"
            sx={{
              marginBottom: "0.5rem",
            }}
          >
            عنوان تیکت
          </Typography>
          <BaseInput
            isSignIn={true}
            isDeactivate={true}
            placeholder={"رسیدگی به پرونده"}
            width="100%"
            id="title"
            onChange={(event) => {
              setInformation({ ...information, title: event.target.value });
            }}
            sx={{
              background: "#fff",
              borderRadius: "0.5rem",
            }}
          />
          <Typography variant="h2" mt={3} mb={1}>
            توضیحات
          </Typography>
          <BaseTextArea
            flex={12}
            minRows={4}
            maxRows={4}
            placeholder="مشکل خود را توضیح دهید"
            onChange={(event) => {
              setInformation({ ...information, discription: event.target.value });
            }}
            style={{
              background: "#fff",
            }}
          />
          <Box display="flex" justifyContent="center" mt={4} width="100%">
            <Button
              variant="m2"
              sx={{
                background: "#c1c1c1",
                color: "#fff",
                "&:hover": {
                  background: "#c1c1c1",
                },
              }}
              onClick={() => navigate("/ticketing")}
            >
              انصراف
            </Button>
            <Button variant="m1" sx={{ width: "165px", ml: 2 }} onClick={handleSubmitForm}>
              ارسال
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default RegisterComplaints;
